module.exports = __webpack_public_path__ + "static/media/wordmark_white.e315a97a.svg";